export const between = ({ min, max, minSelected, maxSelected }) => {
  // inners
  if (min >= minSelected && max <= maxSelected) {
    return true
  }
  // betweens
  if (minSelected > min && minSelected <= max) {
    return true
  }
  if (maxSelected > min && maxSelected <= max) {
    return true
  }

  // outers
  return false
}
